import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Form, Alert, Button, Row, Col } from 'antd';
import AntIcon from '../../shared/components/AntIcon';
import { Link } from 'react-router-dom';

import moment from 'moment';

import {
  formItemLayout,
  renderInput,
  renderTextarea,
  renderDateTime,
  renderSwitch,
  renderSelect,
} from '../../shared/utils/form_components';
import { required, url } from '../../shared/utils/form_validations';

class ArticleForm extends Component {

  render() {
    const { handleSubmit, cancelPath, error, submitting, deleteButton, sneakerModels, tags } = this.props;

    const TagOptions = [{ label: 'Unknown', value: null }]
      .concat(tags.map(({ _id, title }) => ({ label: title, value: _id })));

    const SneakerModelOptions = [{ label: 'Unknown', value: null }]
    .concat(sneakerModels.map(({ _id, name }) => ({ label: name, value: _id })));

    const filterOptions = (value, option) =>
      option.props.children.toLowerCase().includes(value.toLowerCase());

    return (
      <Form layout="horizontal" onSubmit={handleSubmit}>

        <Row>
          <Col lg={18} xs={24}>

            <Form.Item>
              <Row gutter={[8, 8]} type="flex" justify="end" className="page-form-actions">
                <Col>
                  <Button>
                    <Link to={cancelPath || "/news"}>Cancel</Link>
                  </Button>
                </Col>
                <Col>{deleteButton}</Col>
                <Col>
                  <Button
                    disabled={submitting} loading={submitting}
                    type="primary" htmlType="submit"
                  >
                    <AntIcon type="save" />Save
                  </Button>
                </Col>
              </Row>
            </Form.Item>

            {error && <Form.Item><Alert message={error} type="error" /></Form.Item>}

            <Field
              name="title"
              label="Title"
              placeholder="Title"
              component={renderInput}
              validate={required}
              required
            />

            <Form.Item
              {...formItemLayout}
              label="Link"
              required
            >
              <Row gutter={[8, 8]} type="flex" align="middle">
                <Col xs={24} sm={17}>
                  <Field
                    inputOnly
                    name="link"
                    placeholder="Link"
                    component={renderInput}
                    validate={[required, url]}
                  />
                </Col>
                <Col xs={24} sm={{ span: 6, offset: 1 }}>
                  <Field
                    inline
                    name="featured"
                    label="Featured"
                    component={renderSwitch}
                  />
                </Col>
              </Row>
            </Form.Item>

            <Field
              showSearch
              filterOption={filterOptions}
              name="tag"
              label="Tag"
              placeholder="Unknown"
              options={TagOptions}
              component={renderSelect}
            />

            <Form.Item
              {...formItemLayout}
              required
              label="Model"
            >
              <Row gutter={[8, 8]}>
                <Col xs={24} sm={14} md={10}>
                  <Field
                    inputOnly
                    showSearch
                    filterOption={filterOptions}
                    name="sneakerModel"
                    placeholder="Unknown"
                    options={SneakerModelOptions}
                    component={renderSelect}
                  />
                </Col>
              </Row>
            </Form.Item>

            <Form.Item
              {...formItemLayout}
              label="Source"
              required
            >
              <Row gutter={[8, 8]}>
                <Col xs={24} sm={12}>
                  <Field
                    inputOnly
                    name="source"
                    placeholder="Source"
                    component={renderInput}
                    validate={required}
                  />
                </Col>
                <Col xs={24} sm={12} md={{ span: 10, offset: 2 }}>
                  <Field
                    name="date"
                    label="Date"
                    showTime
                    pickerFormat="YYYY-MM-DD HH:mm:ss"
                    normalize={val => moment(val).format()}
                    component={renderDateTime}
                    validate={required}
                    required
                  />
                </Col>
              </Row>
            </Form.Item>

            <Field
              name="image"
              label="Image"
              placeholder="Image Link"
              component={renderInput}
              validate={[required, url]}
              required
            />

            <Field
              name="content"
              label="Content"
              autosize={{ minRows: 5 }}
              required
              component={renderTextarea}
              validate={required}
            />

          </Col>
        </Row>

      </Form>
    );
  }
}

export default reduxForm({ form: 'ArticleForm' })(ArticleForm);
